import {
  Box,
  Checkbox,
  Drawer,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react"; 
import XIcon from "../assets/svg/xIcon.svg"; 
import ArrUp from "../assets/svg/ArrUp.svg"; 
import axios from "axios";
import { GetAllRoles } from "../URLs/Apis"; 
import { useSelector } from "react-redux";

function FillterBy({
  selectedJobTitles, 
  setselectedJobTitles, 
  handleJobTitleChange, 
  open, 
  toggleDrawer, 
  filteredStaff, 
  joinDate, 
  setjoinDate, 
}) {
  const { user } = useSelector((state) => state.auth); 
  const [openFilterjob, setOpenFilterjob] = useState(true);
  const [openFilterdate, setOpenFilterdate] = useState(true);

  const [rolesData, setRolesData] = useState([]);


  const getRolesData = useCallback(() => {
  
    if (!user?.token) {
        console.warn("Authentication token not available for fetching roles.");
        setRolesData([]); 
        return;
    }

    const headers = {
      Authorization: "Bearer " + user?.token,
    };

    axios
      .get(GetAllRoles, { headers })
      .then((response) => {
      
        console.log("Roles Data:", response.data.data.categories);
        setRolesData(response.data.data.categories || []);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error.response?.data || error.message);
        setRolesData([]); // Clear roles on error
      });
  }, [user?.token]);

  useEffect(() => {
   
      getRolesData();
  }, [getRolesData]); // Depend on the memoized function

  // Function to reset all filters
  const resetAllFun = () => {
    setselectedJobTitles([]); // Reset job titles in parent
    setjoinDate(''); // Reset join date in parent
  };

  return (
    // Corrected onClose handler for Drawer
    <Drawer anchor={"right"} open={open} onClose={() => toggleDrawer(false)}>
      <Box sx={{ width: 350, padding: 3 }} role="presentation">
        <div className="filterBy-title">
          <span className="resetAll" onClick={resetAllFun} style={{ cursor: 'pointer' }}> {/* Add cursor style */}
            Reset all
          </span>
          <span className="filterBy_theTitle">Filter By</span>
          {/* Corrected onClick handler for close icon */}
          <div className="resetAll" onClick={() => toggleDrawer(false)} style={{ cursor: 'pointer' }}> {/* Add cursor style */}
            <img className="" src={XIcon} alt="Close filter" /> {/* Add alt text */}
          </div>
        </div>
        <div className="filterBygroping">
          <div className="filterBySection">
            {/* Role Name / Job Title Section (assuming this FilterBy is primarily for Operators/Operation) */}
            <div
              className="front"
              onClick={() => setOpenFilterjob(!openFilterjob)}
              style={{ cursor: 'pointer' }} // Add cursor style
            >
               {/* Assuming 'Operation' context here based on parent component */}
              <span>Role Name</span>
              <img
                src={ArrUp}
                className={`${openFilterjob ? null : "rotat180"}`}
                alt="Toggle section" // Add alt text
              />
            </div>
            <div className={`back ${openFilterjob ? null : "d-none"}`}>
               {/* Render checkboxes for Roles fetched from API */}
                <FormGroup>
                  {rolesData?.map((roleName) => { // Use roleName for clarity
                    return (
                      <FormControlLabel
                        key={roleName} // Use role name as a unique key
                        control={
                          <Checkbox
                            inputProps={{ "aria-label": `Filter by ${roleName}` }} // More descriptive aria-label
                            checked={selectedJobTitles?.includes(roleName)} // Check if this role is selected
                            onChange={() => handleJobTitleChange(roleName)} // Call parent handler on change
                          />
                        }
                        label={roleName}
                      />
                    );
                  })}
                   {rolesData.length === 0 && !user?.token && ( // Show message if roles not loaded (e.g., no token)
                     <div className="text-muted small">Cannot load roles. Authentication missing.</div>
                   )}
                    {rolesData.length === 0 && user?.token && ( // Show message if roles couldn't be fetched with token
                     <div className="text-muted small">No roles found or error fetching roles.</div>
                   )}
                </FormGroup>
            </div>

              <>
                <div
                  className="front"
                  onClick={() => setOpenFilterdate(!openFilterdate)}
                  style={{ cursor: 'pointer' }} // Add cursor style
                >
                  <span>Joined date</span>
                  <img
                    src={ArrUp}
                    className={`${openFilterdate ? null : "rotat180"}`}
                    alt="Toggle section" // Add alt text
                  />
                </div>
                <div className={`back ${openFilterdate ? null : "d-none"}`}>
                  <TextField
                    className="w-100"
                    label="Joined Date"
                    type="date"
                   
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={joinDate} // Controlled by parent state
                    onChange={(e) => setjoinDate(e.target.value)} // Update parent state
                  />
                </div>
              </>

          </div>

          {/* Filter Apply Button - now only closes the drawer */}
          <button onClick={() => toggleDrawer(false)} className="filterBy-Sub">
            Show {filteredStaff} results {/* Displays the count from the parent */}
          </button>
        </div>
      </Box>
    </Drawer>
  );
}

export default FillterBy;